import { DownloadBIcon } from '@prophecy/icons';
import { theme } from '@prophecy/theme';
import { Button, Stack, Text } from '@prophecy/ui-v3';
import { toast } from '@prophecy/ui-v3/Toast';
import { formattedDateTime } from '@prophecy/utils/date';

import { SapAiTermsTestIds } from '../constants';
import { downloadSapAiTerms } from '../Pdf/downloadSapAiTerms';
import { sapAiTerms } from '../sapTermsContent';

const TOAST_WIDTH = theme.width.x560;

function SapAiTermsSuccessToastContent({ acceptedAt, onDismiss }: { acceptedAt: string; onDismiss: () => void }) {
  return (
    <Stack direction='vertical' gap={theme.spaces.x4} align='start'>
      <Text level='sm' weight={theme.fontWeight.semiBold} tone={theme.textColor.primary}>
        Prophecy AI is on for your organization
      </Text>
      <Text level='sm' tone={theme.textColor.secondary}>
        {`Accepted ${formattedDateTime(acceptedAt, { month: 'short', day: 'numeric', year: 'numeric' })} · terms ${sapAiTerms.version}. Your response is recorded.`}
      </Text>
      <Stack direction='horizontal' gap={theme.spaces.x12} alignY='center'>
        <Button variant='linkGray' onClick={onDismiss} data-test-id={SapAiTermsTestIds.toastDismissButton}>
          Dismiss
        </Button>
        <Button
          variant='link'
          icon={<DownloadBIcon type='default' />}
          iconPlacement='left'
          onClick={downloadSapAiTerms}
          data-test-id={SapAiTermsTestIds.toastDownloadButton}>
          Download terms
        </Button>
      </Stack>
    </Stack>
  );
}

export function showSapAiTermsAcceptedToast(acceptedAt: string) {
  const handle = toast.success({
    width: TOAST_WIDTH,
    content: <SapAiTermsSuccessToastContent acceptedAt={acceptedAt} onDismiss={() => handle.close()} />,
    'data-test-id': SapAiTermsTestIds.acceptedToast
  });
}
